import myImg from "../../imgs/selfis.jpg";
import reactImg from "../../imgs/react.png";
import reduxImg from "../../imgs/redux.png";
import sassImg from "../../imgs/sass.png";
import nodeJSImg from "../../imgs/nodeJS.png";
import sequelizeImg from "../../imgs/sequelize.png";
import postgreSQLImg from "../../imgs/postgreSQL.png";
import githubImg from "../../imgs/github.png";
import linkedinImg from "../../imgs/linkedin.png";
import { useSelector } from "react-redux";

const About = () => {
  const { lenguage } = useSelector((s) => s);
  return (
    <>
      <div className="about_container">
        <div className="about-secondBg"></div>
        <div className="name_img">
          <h1>Franco Gutierrez</h1>
          <img src={myImg} alt="myImg" />
        </div>
        <p>
          {lenguage
            ? "I'm Franco Gutierrez, this is my individual project from SoyHenry's acamdemy. This project was created with React, Redux, Sass, for the front end and styles, NodeJS, Sequelize, for the server, and PostgreSQL for the database."
            : "Yo soy Franco Gutierrez, este es mi proyecto individual de la acamdemia de SoyHenry. Este proyecto fue creado con React, Redux, Sass, para el front y los estilos, NodeJS, Sequelize, para el server, y PostgreSQL para la base de datos."}
        </p>
        <h3>{lenguage ? "Used technologies" : "Tecnologias usadas"}</h3>
        <ul>
          <li>
            <img src={reactImg} alt="reactImg" />
            React
          </li>
          <li>
            <img src={reduxImg} alt="reduxImg" />
            Redux
          </li>
          <li>
            <img src={sassImg} alt="sassImg" />
            Sass
          </li>
          <li>
            <img src={nodeJSImg} alt="nodeJSImg" />
            NodeJS
          </li>
          <li>
            <img src={sequelizeImg} alt="sequelizeImg" />
            Sequelize
          </li>
          <li>
            <img src={postgreSQLImg} alt="sequelizeImg" />
            PostgreSQL
          </li>
        </ul>
        <h3>{lenguage ? "Contact information" : "Información de contacto"}</h3>
        <div className="contact-info">
          <a href="https://github.com/franco4457">
            <img src={githubImg} alt="githubImg" />
          </a>
          <a href="https://www.linkedin.com/in/francoegi/">
            <img src={linkedinImg} alt="linkedinImg" />
          </a>
        </div>
      </div>
    </>
  );
};
export default About;
